/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Complete_Signin_WaitingInputs */

const en_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This window will update automatically once you've signed in.`)
};

const fr_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette fenêtre se mettra à jour automatiquement une fois connecté.`)
};

const de_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Fenster wird sich nach der Anmeldung automatisch aktualisieren.`)
};

const it_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa finestra si aggiornerà automaticamente una volta effettuato l'accesso.`)
};

const ru_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это окно обновится автоматически после входа в систему.`)
};

const es_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ventana se actualizará automáticamente una vez que haya iniciado sesión.`)
};

const zh_cn2_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后，此窗口将自动更新。`)
};

const ja_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインすると、このウィンドウは自動的に更新されます。`)
};

const hi_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग इन करने के बाद यह विंडो अपने आप अपडेट हो जाएगी।`)
};

const pt_pt2_login_complete_signin_waiting = /** @type {(inputs: Login_Complete_Signin_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta janela será atualizada automaticamente assim que você fizer login.`)
};

/**
* | output |
* | --- |
* | "This window will update automatically once you've signed in." |
*
* @param {Login_Complete_Signin_WaitingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_complete_signin_waiting = /** @type {((inputs?: Login_Complete_Signin_WaitingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Complete_Signin_WaitingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_complete_signin_waiting(inputs)
	if (locale === "de") return de_login_complete_signin_waiting(inputs)
	if (locale === "it") return it_login_complete_signin_waiting(inputs)
	if (locale === "ru") return ru_login_complete_signin_waiting(inputs)
	if (locale === "es") return es_login_complete_signin_waiting(inputs)
	if (locale === "zh-CN") return zh_cn2_login_complete_signin_waiting(inputs)
	if (locale === "ja") return ja_login_complete_signin_waiting(inputs)
	if (locale === "hi") return hi_login_complete_signin_waiting(inputs)
	if (locale === "pt-PT") return pt_pt2_login_complete_signin_waiting(inputs)
	return en_login_complete_signin_waiting(inputs)
});